import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-rfqmenu',
  templateUrl: './rfqmenu.component.html',
  styleUrls: ['./rfqmenu.component.scss']
})
export class RfqmenuComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
